<template>
  <div>
     <box-header title="油品批发提油统计">
       <div class="box-header-tab">
         <div @click="changeType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
         <div @click="changeType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
         <div @click="changeType('day')" class="tab-item" :class="{'active': type === 'day'}">日视图</div>
       </div>
     </box-header>

     <div class="box" style="height: 340px;background: rgba(7,17,32,.3);">
       <box-border line></box-border>

       <div class="box-filter_space">
         <div class="box-count">
           <span class="count-name">总量：</span>
           <span class="count-value">{{count}}</span>
           <span class="count-unit">吨</span>
         </div>

         <div v-if="type === 'year'" class="box-select">
           <el-select :value="currentYear" @change="changeYear" placeholder="请选择">
             <el-option
                 v-for="(year,index) in yearList"
                 :key="index"
                 :value="year"
                 :label="year + '年'"
             >
             </el-option>
           </el-select>
         </div>
         <div v-if="type === 'month'" class="box-select">
           <el-select :value="currentMonth" @change="changeMonth" placeholder="请选择">
             <el-option
                 v-for="(month,index) in monthList"
                 :key="index"
                 :value="month"
                 :label="month + '月'"
             >
             </el-option>
           </el-select>
         </div>

         <div v-if="type === 'day'" class="box-select">
           <el-select :value="currentDay" @change="changeDay" placeholder="请选择">
             <el-option
                 v-for="(day,index) in dayList"
                 :key="index"
                 :value="day"
                 :label="day + '日'"
             >
             </el-option>
           </el-select>
         </div>

       </div>
       <div style="height: calc(100% - 80px);background: rgba(10, 27, 46, .51);">
         <div id="oilChart" class="chart"></div>
       </div>
     </div>
  </div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
const yearMonthList = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export default {
  name: "ChartPhotoVoltaic",
  components: { BoxBorder, BoxHeader },
  data() {
    return {
      chart: null,
      yearList: ["2023","2024","2025","2026"],
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      dayList:[],
      statisticsType:"oil",
      count:0,
      type:"year",
      currentYear:"",
      currentMonth:"",
      currentDay:"",
      data:[],
      category:[],
      sectionData:[]
    };
  },
  mounted() {
    this.$nextTick(() => {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1; // 月份从 0 开始，所以要 +1
      let daysInMonth = new Date(year, month, 0).getDate();
      this.currentDay = time.getDate();
      this.dayList = Array.from({ length: daysInMonth }, (_, i) => i + 1);
      this.currentYear =  new Date().getFullYear() +"";
      this.getOilChart();
      this.bindEvents();
    });
  },
  methods: {
    bindEvents(){
      this.chart.on("click", (data) => {
        if (this.type === "year") {
          return false;
        }
        if(this.type === "month") {
          let day = this.category[data.dataIndex];
          if (day) {
            day = parseInt(day);
          }
          const date = this.currentYear + '-' + this.$util.padStartInt(this.currentMonth,2) + '-' + this.$util.padStartInt(day,2);
          console.log(date)
           // this.$refs.ModalOilDetail.open({date});
        }
      });
    },
    getPhotovoData(){
      this.chart = this.$echarts.init(document.getElementById("chartPhotovoltaic"));
      this.getGfData();
    },
    //获取油站数据
    changeType(type){
      if(type === 'month' && !this.currentMonth){
        let time = new Date();
        this.currentMonth = (time.getMonth() + 1) + "";
      }
      this.type = type;
      this.getOilData();
    },
    changeYear(year) {
      this.currentYear = year;
      this.getOilData();
    },
    changeMonth(month) {
      this.currentMonth = month;
      let time = new Date();
      let year = time.getFullYear();
      let daysInMonth = new Date(year, month, 0).getDate();
      this.dayList = Array.from({ length: daysInMonth }, (_, i) => i + 1);
      this.getOilData();
    },
    changeDay(day){
      this.currentDay = day;
      this.getOilData();
    },
    getOilChart(){
      this.chart = this.$echarts.init(document.getElementById("oilChart"));
      this.getOilData();
    },
    getOilData(){
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)"
      });

      if (this.type === "year") {
        this.$api.getOliStatisticsByYear({"year":this.currentYear,"itemId":""}).then(res => {
              this.disposeData(res.data);
        });
      }

      if (this.type === "month") {
        this.$api.getOliStatisticsByMonth({'year':this.currentYear,'month':this.currentMonth}).then(res => {
             this.disposeData(res.data);
        });
      }
      //日视图
      if(this.type === "day"){
        this.$api.getOliStatisticsByDay({'year':this.currentYear,'month':this.currentMonth,'day':this.currentDay}).then(res => {
          this.disposeData(res.data);
        });
      }
    },
    disposeData(sourceData){   
      this.data = sourceData.map(item => Number(item.dl));
      this.sectionData = this.data.map(item => item + 90);
      if (this.type === "year") {
        this.category = yearMonthList;
        if (this.data.length < 12) {
          for (let i = 0; i < 12; i++) {
            if (!this.data[i]) this.data.push(0);
          }
        }
        this.max = this.$util.formatInt(this.$lodash.max(this.data) + 1000, 3);
      } else if(this.type === "month") {
        this.category = sourceData.map(item => item.day + "日");
        this.max = this.$util.formatInt(this.$lodash.max(this.data) + 100, 2);
      } else if(this.type === "day") {
        this.category = sourceData.map(item => item.day + "时");
        this.max = this.$util.formatInt(this.$lodash.max(this.data) + 100, 2);
      }
      this.count = this.$lodash.sum(this.data).toFixed(2);
      this.renderChart();
    },
    renderChart(){
      this.chart.hideLoading();
      const barWidth = 30;
      const colorArr = ["#F66E67", "#F89E85", "#FBCCB2"];
      const color = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0]
          },
          {
            offset: 0.5,
            color: colorArr[0]
          },
          {
            offset: 0.5,
            color: colorArr[1]
          },
          {
            offset: 1,
            color: colorArr[1]
          }
        ]
      };

      let options = {
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: "<div class='title'>{a0}</div><div class='name'>{b0}</div><div class='value'>{c0}<span class='unit'>吨</span></div>",
          textStyle: {
            fontSize: 30
          }
        },
        grid: {
          top: 45,
          bottom: 30,
          left: 30,
          right: 50,
          containLabel: true
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true
        }],
        xAxis: {
          type: "category",
          data: this.category,
          splitNumber: 6.5,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          boundaryGap: true
        },
        yAxis: {
          type: "value",
          name: "吨",
          nameLocation: "end",
          nameGap: 25,
          nameTextStyle: {
            fontSize: 22,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .6)"
          },
          min: 0,
          max: this.max,
          minInterval: 1000,
          splitNumber: 5,
          axisLabel: {
            margin: 25,
            fontSize: 24,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .8)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          }
        },
        series: [
          {
            z: 1,
            name: "油品批发提油统计",
            type: "bar",
            barWidth: barWidth,
            data: this.data,
            itemStyle: {
              normal: {
                color: color
              }
            },
            label: {
              show: false,
              position: "top",
              distance: 20,
              fontSize: 16,
              fontFamily: "screen",
              color: "#F89E85"
            },
            emphasis: {
              label: {
                fontSize: 18
              }
            },
            animation: true
          },
          {
            z: 2,
            name: "加油站销量统计",
            type: "pictorialBar",
            data: this.sectionData,
            symbol: "diamond",
            symbolOffset: [0, "50%"],
            symbolSize: [barWidth, 10],
            itemStyle: {
              normal: {
                color: color
              }
            },
            animation: true
          },
          {
            z: 3,
            name: "加油站销量统计",
            type: "pictorialBar",
            symbolPosition: "end",
            data: this.data,
            symbol: "diamond",
            symbolOffset: [0, "-56%"],
            symbolSize: [barWidth + 1, 10],
            itemStyle: {
              normal: {
                borderWidth: 2,
                color: colorArr[2]
              }
            },
            animation: true
          }
        ]
      };

      this.chart.setOption(options);

      this.chart.dispatchAction({
        type: 'dataZoom',
        startValue: this.data.length - 11,
        endValue: this.data.length
      })
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep(.el-radio-button__inner) {
  font-size: 25px; /* 你可以修改这个值 */
}

::v-deep(.el-radio-button__inner) {
  color: rgba(161, 197, 234, 0.7);
  background-color: #070f1a;
  border-color: #9e9898;
}

/* 选中时的颜色 */
::v-deep(.el-radio-button.is-active .el-radio-button__inner) {
  color: #E7F3FF;
  background-color: #15406b;
  border-color: #9e9898;
}

/* 鼠标悬停时的颜色 */
::v-deep(.el-radio-button:hover .el-radio-button__inner) {
  color: #E7F3FF;
  background-color: #15406b;
  border-color: #9e9898;
}

.box-filter {
  display: flex;
  justify-content: end;
  padding: 15px 30px 0;
  box-sizing: border-box;
  height: 60px;
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}

.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;

  .tab-item {
    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 25px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }
  }
}

.box-count {
  height: 50px;
  line-height: 45px;

  .count-name {
    font-size: 22px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 32px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 22px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}

.box-filter_space{
  display: flex;
  justify-content: space-between;
  padding: 15px 30px 0;
  box-sizing: border-box;
  height: 60px;
}
</style>
